import React, { useState, useEffect } from "react";
import sslIcon from "../../../assets/img/SSLIcon.png";
import bgBanner from "../../../assets/img/bg-banner-location.png";

const primaryColor = "#003663";

const BookingTopBanner = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ position: "relative", zIndex: 0, width: "100%", marginBottom: "60px" }}>
      {/* Full width background image */}
      <div
        style={{
          width: "100%",
          height: "250px",
          backgroundImage: `url(${bgBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      {/* Container that matches content width */}
      <div className="container" style={{ 
        position: "relative", 
        maxWidth: "1400px", 
        padding: isMobile ? "0 16px" : 0 
      }}>
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "calc(100% - 32px)" : "100%",
            background: "#FFFFFF",
            borderRadius: "12px",
            padding: "20px 28px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
            color: primaryColor,
          }}
        >
          {/* Left Section: Heading */}
          <div style={{ flex: 1, minWidth: "260px" }}>
            <h4
              style={{
                margin: 0,
                fontWeight: "bolder",
                color: primaryColor,
                fontSize: "1.3rem",
                lineHeight: 1.4,
              }}
            >
              Add guest and payment details
            </h4>
          </div>

          {/* Right Section: Subtitle and Icon */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              flexWrap: "nowrap",
            }}
          >
            <div
              style={{
                fontSize: "0.95rem",
                color: primaryColor,
                lineHeight: 1.4,
                textAlign: "right",
                fontWeight: 500
              }}
            >
              <div>With SSL encryption, your personal data is</div>
              <div>always protected.</div>
            </div>
            <img src={sslIcon} alt="SSL Secured" style={{ height: 60, width: 60 }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingTopBanner;
